import i18n from "@/i18n";

export default {
  questionList: {
    columnHeader: [
      {
        id: 'sequence',
        textLabel: i18n.t('排序'),
        type: 'text',
        tabletHide: false,
        width: '10%',
      },
      {
        id: 'title',
        textLabel: i18n.t('題目'),
        type: 'text-chip',
        tabletHide: false,
      },
      {
        id: 'tempQuesStatus',
        type: 'badge',
        tabletHide: false,
      },
      {
        id: 'edit',
        textLabel: i18n.t('編輯'),
        type: 'icon',
        tabletHide: false,
        width: '5%',
      },
      {
        id: 'copy',
        textLabel: i18n.t('複製'),
        type: 'icon',
        tabletHide: false,
        width: '5%',
      },
      {
        id: 'remove',
        textLabel: i18n.t('移除'),
        type: 'icon',
        tabletHide: false,
        width: '5%',
      },
    ]
  },
  recordList: {
    columnHeader: [
      {
        id: 'result',
        textLabel: i18n.t('結果'),
        type: 'icon',
        tabletHide: false,
        width: '150px',
        textAlignLeft: true,
      },
      {
        id: 'passRate',
        textLabel: i18n.t('合規率'),
        type: 'text',
        tabletHide: true,
      },
      {
        id: 'date',
        textLabel: i18n.t('完成日'),
        type: 'text',
        width: '105px',
        noWrap: true,
      },
      {
        id: 'checkers',
        textLabel: i18n.t('答題者'),
        type: 'avatars',
        tabletHide: false,
      },
      {
        id: 'reviewers',
        textLabel: i18n.t('覆核者'),
        type: 'avatars',
        tabletHide: false,
      },
      {
        id: 'download',
        icon: 'icon-cloud-download',
        textLabel: i18n.t('匯出'),
        type: 'downloadPopup',
      },
    ],
  },
  sampleRecordList: {
    columnHeader: [
      {
        id: 'recordAt',
        textLabel: i18n.t('抽檢日期時間'),
        type: 'text',
        tabletHide: false,
        width: 'auto',
      },
      {
        id: 'recorder',
        textLabel: i18n.t('抽檢人'),
        type: 'text',
        tabletHide: false,
        width: 'auto',
      },
      {
        id: 'result',
        textLabel: i18n.t('結果'),
        type: 'badge',
        tabletHide: false,
        width: 'auto',
      },
    ],
  },
  scheduleSetting: {
    columnHeader: [
      {
        id: 'owner',
        textLabel: i18n.t('設定者'),
        type: 'avatar',
        tabletHide: false,
      },
      {
        id: 'createdAt',
        textLabel: i18n.t('建立時間'),
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'updatedAt',
        textLabel: i18n.t('更新時間'),
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'type',
        textLabel: i18n.t('排程種類'),
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'duration',
        textLabel: i18n.t('排程日期'),
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'repeatInterval',
        textLabel: i18n.t('重複設定'),
        type: 'text',
        tabletHide: false,
        whiteSpace: 'pre-line',
      },
      {
        id: 'checkers',
        textLabel: i18n.t('答題者'),
        type: 'avatars',
        tabletHide: false,
      },
      {
        id: 'reviewers',
        textLabel: i18n.t('覆核者'),
        type: 'avatars',
        tabletHide: false,
      },
    ]
  },
  focusRadioItems: {
    buttonItems: [
      {
        id: 1,
        value: 'true',
        textLabel: i18n.t('是'),
      },
      {
        id: 0,
        value: 'false',
        textLabel: i18n.t('否'),
      },
    ],
  },
  quesTypeRadioItems: {
    buttonItems: [
      {
        id: 'single-choice',
        textLabel: '單選題',
      },
      {
        id: 'num',
        textLabel: '數值題',
      },
      {
        id: 'date',
        textLabel: '日期時間',
      },
      {
        id: 'text',
        textLabel: '文字敘述',
      },
    ],
  },
  controlLimitCustomMessages: {
    customedMinValue: i18n.t('管制界線下限不可小於合規界線'),
    customedMaxValue: i18n.t('管制界線上限不可大於合規界線'),
    max_value: i18n.t('管制界線下限不可大於管制界線上限'),
    min_value: i18n.t('管制界線上限不可小於管制界線下限'),
  },
  specLimitCustomMessages: {
    customedMinValue: i18n.t('合規界線下限不可大於管制界線'),
    customedMaxValue: i18n.t('合規界線上限不可小於管制界線'),
    max_value: i18n.t('合規界線下限不可大於合規界線上限'),
    min_value: i18n.t('合規界線上限不可小於合規界線下限'),
  },
  analysisColumnHeader: {
    assignment: [
      {
        id: 'multiSystemSubclasses',
        textLabel: i18n.t('領域'),
        type: 'chips',
        width: '200px',
      },
      {
        id: 'title',
        textLabel: i18n.t('名稱'),
        type: 'text',
        width: '350px',
      },
      {
        id: 'date',
        textLabel: i18n.t('期限'),
        type: 'text',
        width: '105px',
        noWrap: true,
      },
      {
        id: 'duration',
        textLabel: '時段',
        type: 'text',
        width: '110px',
        noWrap: true,
      },
      {
        id: 'checkers',
        textLabel: i18n.t('答題者'),
        type: 'avatars',
        width: 'auto',
      },
    ],
    record: [
      {
        id: 'result',
        textLabel: i18n.t('結果'),
        type: 'icon',
        textAlignLeft: true,
        width: '200px',
      },
      {
        id: 'multiSystemSubclasses',
        textLabel: i18n.t('領域'),
        type: 'chips',
        width: '350px',
      },
      {
        id: 'title',
        textLabel: i18n.t('名稱'),
        type: 'text',
      },
      {
        id: 'date',
        textLabel: i18n.t('完成日'),
        type: 'text',
        width: '105px',
        noWrap: true,
      },
      {
        id: 'duration',
        textLabel: '時段',
        type: 'text',
        width: '105px',
        noWrap: true,
      },
      {
        id: 'passRate',
        textLabel: i18n.t('合規率'),
        type: 'text',
      },
      {
        id: 'checkers',
        textLabel: i18n.t('答題者'),
        type: 'avatars',
      },
      {
        id: 'reviewers',
        textLabel: i18n.t('覆核者'),
        type: 'avatars',
      },
      {
        id: 'reviewStatus',
        textLabel: i18n.t('覆核狀態'),
        type: 'text',
      },
      {
        id: 'download',
        icon: 'icon-cloud-download',
        textLabel: i18n.t('匯出'),
        type: 'downloadPopup',
      },
      {
        id: "sample",
        type: "button",
        tabletHide: false,
        width: "5%",
      }
    ],
  },
  numConditionTypeRadioItems: {
    buttonItems: [
      {
        id: 'custom-num',
        textLabel: '自訂條件式',
      },
      {
        id: 'control-limit',
        textLabel: 'Control Limit 管制界線 / Spec Limit 合規界線',
      },
      {
        id: 'num-only',
        textLabel: '不使用條件式（單純數值輸入）',
      },
    ],
  },
  riskItems: [
    {
      id: '21',
      textLabel: '低風險',
    },
    {
      id: '22',
      textLabel: '中風險',
    },
    {
      id: '23',
      textLabel: '高風險',
    },
    {
      id: '25',
      textLabel: '無異常',
    },
  ],
  operatorItems: [
    {
      id: 'gt',
      textLabel: '大於 >',
    },
    {
      id: 'gte',
      textLabel: '大於等於 ≧',
    },
    {
      id: 'lt',
      textLabel: '小於 <',
    },
    {
      id: 'lte',
      textLabel: '小於等於 ≦',
    },
    {
      id: 'eq',
      textLabel: '等於 =',
    },
    {
      id: 'neq',
      textLabel: '不等於 ≠',
    },
    {
      id: 'in',
      textLabel: '介於',
    },
    {
      id: 'not_in',
      textLabel: '不介於',
    },
  ],
  alertMessages: {
    ques: {
      create: '新增題目，會影響正在進行中的點檢作業跟點檢草稿，確定要新增題目嗎？',
      update: '編輯題目，會影響正在進行中的點檢作業跟點檢草稿，確定要編輯題目嗎？',
      delete: '刪除題目，會影響正在進行中的點檢作業跟點檢草稿，確定要刪除題目嗎？',
    },
    checklist: {
      update: '編輯點檢表，會影響正在進行中的點檢作業跟點檢草稿，確定要編輯點檢表嗎？',
      delete: '刪除點檢表，會影響正在進行中的點檢作業跟點檢草稿，確定要刪除點檢表嗎？',
    },
    schedule: {
      update: '編輯點檢排程，會影響正在進行中的點檢作業跟點檢草稿，確定要編輯點檢排程嗎？',
    },
    sample: {
      delete: '確定要刪除此抽檢記錄嗎？',
    }
  }
}
